(function ($) {
	$.fn.ellipsis = function (ellipsisElement) {
		ellipsisElement = ellipsisElement || "<a href='javascript:;'>...</a>";
		return this.each(function () {
			var el = $(this);
			if (el.css("overflow") == "hidden") {
				var text = el.html();
				var multiline = el.hasClass('multiline');
				var t = $(this.cloneNode(true))
						.hide()
						.css('position', 'absolute')
						.css('overflow', 'visible')
						.width(multiline ? el.width() : 'auto')
						.height(multiline ? 'auto' : el.height())
					;

				el.after(t);
				if (t.height() > el.height()) {
					el.append(ellipsisElement);
				}
				t.remove();
			}
		});
	};
})(jQuery);
